const StorageService = (() => {
    /**
     * @param {string} country 
     * @param {string} lang 
     * @param {string} sessionId 
     * @param {string} encryptedSessionId 
     * @param {object} userData 
     * @param {string} countryText 
     * @param {object} customerProfile 
     */
    const setDataInStorage = (country, lang, sessionId, encryptedSessionId, userData, countryText, customerProfile) => {
        try {
            const accountNbr = customerProfile?.data?.customerProfile?.customer?.accountNumber
            const registrationDate = customerProfile?.data?.customerProfile?.customer?.registrationDate
            let sender = null;
            if (accountNbr) {
                sender = {
                    "email": userData.emailId,
                    "verificationStatus": "N",
                    "termsConditionFlag": "1",
                    "myWuNumber": accountNbr,
                    "isLoggedIn": true,
                    "address": {
                        "countryIsoCode": country.toUpperCase()
                    },
                    "additionalPreferedAccountNumber": accountNbr,
                    "issueDate": registrationDate?.split(' ')[0]?.replace(/-/g, ""),
                    "mobileNumber": {},
                    "identityVerificationStatus": "N",
                    "accountPreferences": {
                        "optOutMarketing": "true",
                        "directMail": "false",
                        "message": "false",
                        "email": "true",
                        "telephoneCall": "false",
                        "optInShare": "true",
                        "thirdpartyDatasharingConsent": "true",
                        "whatsAppMsg": "false"
                    },
                    "registrationDetails": {
                        "registrationDate": registrationDate,
                        "registrationStatus": "P"
                    },
                    "customerLevelCode": customerProfile?.data?.customerProfile?.customer?.customerLevelCode// profile
                };
            } else {
                sender = {
                    email: userData.emailId,
                    password: userData.password
                };
            }

            let receiverCountry = window.receiverCountry || 'MX';
            const receiverCountryName = countryCurrencyDefaults?.countries?.filter((cdata) => cdata.country.isCode === receiverCountry)[0]?.country?.name;
            const data = {
                sessionId: sessionId,
                encryptedSessionId: encryptedSessionId,
                sender: sender,
                corridor: {
                    senderCountry: {
                        isoCode: country.toUpperCase(),
                        name: countryText
                    },
                    receiverCountry: {
                        isoCode: receiverCountry,
                        name: receiverCountryName
                    },
                    receiverCurrency: ISO_CODES_COUNTRIES_CURRENCIES[receiverCountry],
                    senderCurrency: ISO_CODES_COUNTRIES_CURRENCIES[country.toUpperCase()],
                    senderCurrencyArray: [{ currency: ISO_CODES_COUNTRIES_CURRENCIES[country.toUpperCase()] }],
                    receiverCurrencyArray: [{ currency: ISO_CODES_COUNTRIES_CURRENCIES[receiverCountry] }],

                }
            };
            const jsonData = JSON.stringify(data);
            sessionStorage.setItem("app", jsonData);
            sessionStorage.setItem("cookiestore", jsonData);
            sessionStorage.setItem('sc_register_success', 'true');
            CookieService.setCookie('SessionId', sessionId, 30, '/', true, ".westernunion.com");
            CookieService.setCookie('EncryptedSessionId', encryptedSessionId, 30, `/${country}/${lang}`, true, ".westernunion.com");
        } catch (e) {
            console.log(e)
        }
    }

    return {
        setDataInStorage,
    };
})();